import React from 'react';

const SCORE_LABELS = {
  ai_visibility: 'AI Visibility',
  knowledge_graph: 'Knowledge Graph',
  trust: 'Trust',
  brand_authority: 'Brand Authority',
  brand_consistency: 'Brand Consistency',
  entity: 'Entity',
  schema: 'Schema',
  reviews: 'Reviews',
  citations: 'Citations',
  backlinks: 'Backlinks',
  media: 'Media',
  news: 'News',
  podcasts: 'Podcasts',
  videos: 'Videos',
  speaking: 'Speaking',
  social: 'Social',
  content_freshness: 'Content Freshness',
};

function scoreColor(v) {
  if (v >= 80) return 'hsl(var(--success))';
  if (v >= 60) return 'hsl(var(--primary))';
  if (v >= 45) return 'hsl(var(--warning))';
  return 'hsl(var(--destructive))';
}

export default function ScoreGrid({ scores = {}, testid }) {
  const entries = Object.entries(scores);
  return (
    <div data-testid={testid} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      {entries.map(([key, value]) => (
        <div
          key={key}
          className="card-hover rounded-lg border border-border bg-card p-4"
        >
          <div className="text-xs uppercase tracking-wider text-muted-foreground">
            {SCORE_LABELS[key] || key}
          </div>
          <div className="mt-2 flex items-end justify-between">
            <div className="score-num text-3xl" style={{ color: scoreColor(value) }}>{value}</div>
            <div className="text-xs text-muted-foreground">/100</div>
          </div>
          <div className="mt-3 h-1.5 bg-secondary rounded-full overflow-hidden">
            <div
              className="h-full rounded-full"
              style={{ width: `${value}%`, background: scoreColor(value) }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
